import amapi from '@/api/amapi'

const initialState = () => ({
  cancellation: {},
  cancellation_type: '',
  selected_cr_service: {},
  selected_cr_addons: [],
  cr_check: {},
  cr_reasons_data: {},
  cr_reasons_list: [],
  cr_id: null,
  reason_id: null,
  cr_guided: {},
  primary_services_loaded: false,
  hasNoCard: false,
  cancellations: [],
})

const state = initialState

const getters = {
  cancellation: state => state.cancellation,
  cancellation_type: state => state.cancellation_type,
  selected_cr_service: state => state.selected_cr_service,
  selected_cr_addons: state => state.selected_cr_addons,
  cr_reasons_list: state => state.cr_reasons_list,
  cr_id: state => state.cr_id,
  reason_id: state => state.reason_id,
  cr_guided: state => state.cr_guided,
  hasNoCard: state => state.hasNoCard,
  cancellations: state => state.cancellations,
}

const mutations = {
  SET_CANCELLATION: (state, data) => {
    state.cancellation = data
  },
  SET_CR_REASONS_LIST: (state, cr_reasons_data) => {
    state.cr_reasons_list = cr_reasons_data.reasons
    state.cr_id = Number(cr_reasons_data.crid)
  },
  SET_REASON_ID: (state, reason_id) => {
    state.reason_id = reason_id
  },
  SET_CR_GUIDED: (state, response) => {
    state.cr_guided = response
  },
  SET_NOCARD_NOTICE (state, hasNoCard) {
    state.hasNoCard = hasNoCard
  },
  CLEAR_CANCEL_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_CANCELLATIONS: (state, list) => {
    state.cancellations = list
  },
}

const actions = {
  async getCancellation ({ commit }, cr_id) {
    try {
      console.log('store')
      const response = await amapi.makecall('cr_view', { cr_id })

      commit('SET_CANCELLATION', response.cr_data)
      // return response
      return {}
    } catch (e) {
      throw e
    }
  },
  async cancellationReply ({ commit }, data) {
    try {
      return amapi.makecall('cr_reply', { ...data })
    } catch (e) {
      throw e
    }
  },
  async getCRReasons ({ commit, state }, { type, service_id, addons }) {
    try {
      const data = state.cr_reasons_data
      data.check_timeframe = state.cr_check.timeframe
      const response = await amapi.makecall('cr_reasons', { ...data, type, service_id, addons })

      commit('SET_CR_REASONS_LIST', response)
      return response
    } catch (e) {
      throw e
    }
  },
  async stopRenewal ({ commit }, service_id) {
    const response = await amapi.makecall('cr_reasons', { type: 'hosting', service_id })

    console.log(response)
  },
  async sendCRGuided ({ commit }, data) {
    try {
      commit('SET_REASON_ID', data.reason)

      const response = await amapi.makecall('cr_guided', { ...data })

      commit('SET_CR_GUIDED', response)
      return response
    } catch (e) {
      throw e
    }
  },
  async sendCREscalate ({ state }) {
    try {
      return amapi.makecall('cr_escalate', { cr_id: state.cr_id })
    } catch (e) {
      throw e
    }
  },
  async sendCRDeclined ({ state }) {
    try {
      return amapi.makecall('cr_declined', { cr_id: state.cr_id })
    } catch (e) {
      throw e
    }
  },
  async sendCRClose ({ state }) {
    try {
      return amapi.makecall('cr_close', { cr_id: state.cr_id })
    } catch (e) {
      throw e
    }
  },
  async sendCRExtra ({ state, commit }) {
    try {
      return amapi.makecall('cr_extra', {
        cr_id: state.cr_id,
      })
    } catch (e) {
      throw e
    }
  },
  async sendCROpen ({ commit }, data) {
    try {
      return amapi.makecall('cr_open', { ...data })
    } catch (e) {
      throw e
    }
  },
  checkPendingCancellations ({ commit }, notices = null) {
    if (!notices || !Array.isArray(notices)) return
    const hasNoCard = !!notices.find((notice) => notice.type === 'nocard')
    commit('SET_NOCARD_NOTICE', hasNoCard)
  },
  async getCancellations ({ commit, rootGetters }) {
    try {
      const response = await amapi.makecall('cr_list')

      commit('SET_CANCELLATIONS', response.cr_list)
      return response
    } catch (e) {
      throw e
    }
  },
  async sendCrExpedite ({ commit }, data) {
    try {
      await amapi.makecall('cr_expedite', { ...data })
    } catch (e) {
      throw e
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
